<template lang="pug">
v-dialog(v-model='visible' max-width='400')
  v-card
    v-card-title.headline
      | {{ title || "¿Estás seguro?" }}
    v-card-text
      | {{ message || "Esta acción no se puede deshacer." }}
    v-autocomplete(
      class="mx-2"
      v-model="selectedUser"
      :items="userEmails"
      outlined
      dense
      small-chips
      label="Seleccione usuario")
    v-card-actions
      v-spacer
      v-btn(:loading="loading" text='' @click='close') Cancelar
      div(v-if="confirm")
        v-btn(
          class="white--text"
          :loading="loading"
          color='red'
          @click='confirm') Confirmar
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'ConfirmDialog',

  props: {
    title: {
      type: String,
      default: '¿Estás seguro?',
    },
    message: {
      type: String,
      default: 'Esta acción no se puede deshacer.'
    },
    value: Boolean, // Prop para controlar la visibilidad desde el padre
    loading: {
      type: Boolean,
      default: false
    },
  },

  data: () => ({
    selectedUser: null,
  }),

  computed: {
    ...mapState('auth', ['userEmails']),
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val); // Permite el uso con v-model
      },
    },
  },

  methods: {
    confirm() {
      this.$emit('confirm');
      // this.close();
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
